module.exports = __webpack_public_path__ + "static/media/chevron-left.eff43cca.svg";